import React, { useEffect, useState } from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { api, IMAGES } from "../lib/api";
import { Seo } from "../components/site/Seo";
import { Reveal } from "../components/site/Reveal";
import { BackgroundGrid, NodeField } from "../components/site/RouteLine";
import { LeadForm } from "../components/site/LeadForm";

export default function Contact() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/content").then((r) => setS(r.data.settings?.settings || {})).catch(() => {}); }, []);

  return (
    <div data-testid="contact-page">
      <Seo title="Contact — Your Next Mile Starts Here" description="Tell us where your trucking business is today and where you're trying to go. Reach Next Mile Compliance for dispatch, HR, startup, training, and safety audit support." />

      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.sunsetTruck} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-[#060A17]/85" />
        </div>
        <BackgroundGrid className="opacity-30" />
        <NodeField />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <Reveal><p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Get in touch</p></Reveal>
            <Reveal delay={0.1}>
              <h1 className="font-head text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight">YOUR NEXT MILE <span className="nm-gold-text">STARTS HERE.</span></h1>
            </Reveal>
            <Reveal delay={0.2}><p className="mt-5 text-gray-300 text-lg">Tell us where your trucking business is today and where you're trying to go.</p></Reveal>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 items-start">
            <div className="lg:col-span-1 space-y-4">
              {[
                s.phone && { icon: Phone, label: "Call us", val: s.phone, href: `tel:${s.phone}` },
                s.email && { icon: Mail, label: "Email us", val: s.email, href: `mailto:${s.email}` },
                s.address && { icon: MapPin, label: "Visit us", val: s.address, href: null },
              ].filter(Boolean).map((c, i) => (
                <Reveal key={i} delay={i * 0.1}>
                  <a href={c.href || undefined} className="flex items-center gap-4 nm-card rounded-xl p-5 hover:border-[#D4AF37]/50 transition-colors" data-testid={`contact-info-${i}`}>
                    <div className="w-11 h-11 rounded-xl nm-gold-bg flex items-center justify-center shrink-0"><c.icon className="text-[#0B132B]" size={19} /></div>
                    <div><p className="text-xs text-gray-400">{c.label}</p><p className="text-white font-semibold text-sm">{c.val}</p></div>
                  </a>
                </Reveal>
              ))}
              <Reveal>
                <div className="nm-card rounded-xl p-6">
                  <p className="font-head text-lg font-bold text-white mb-2">We serve everyone.</p>
                  <p className="text-gray-400 text-sm">From brand-new owner-operators to established fleets — new MC authorities are always welcome.</p>
                </div>
              </Reveal>
            </div>

            <div className="lg:col-span-2">
              <LeadForm source="contact" submitLabel="LET'S TALK TRUCKING" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
